<ng-container [formGroup]="formParent">
  <!-- TODO ha nincs label.. hidden? vagy valahogy egy külső labellel összekapcsolni? -->
  <div class="label-container">
    <label
      *ngIf="label"
      [for]="id"
      [class.required]="required && !hideRequiredLabel"
      >{{ label | translate }}</label
    >
    <mat-icon *ngIf="labelInfo" class="info-icon" [matTooltip]="labelInfo"
      >info</mat-icon
    >
  </div>
  <div class="form-field-container">
    <mat-select
      [formControlName]="name"
      [(ngModel)]="value"
      [id]="id"
      [attr.readonly]="readonly"
      [attr.aria-required]="required ? true : null"
      [multiple]="multiple"
      [errorStateMatcher]="errorStateMatcher"
      class="easy-select"
      [placeholder]="placeholder | translate"
      floatPlaceholder="never"
      #easySelect
      (keydown)="onSelectField($event)"
      (wheel)="onScroll($event)"
    >
      <mat-select-trigger *ngIf="differentLabelWhenSelected">
        <ng-container *ngIf="multiple; else simpleOptionLabel">
          <span *ngFor="let item of value; let last = last"
            >{{ translatePrefixForSelected + item | translate
            }}{{ last ? "" : "," }}</span
          >
        </ng-container>
        <ng-template #simpleOptionLabel>
          <span>{{ translatePrefixForSelected + value | translate }}</span>
        </ng-template>
      </mat-select-trigger>
      <mat-option *ngIf="hasEmptyOption && !multiple" [value]="null">{{
        "EMPTY_SELECTION" | translate
      }}</mat-option>

      <ng-template let-item #simpleMatOption>
        <mat-option
          #matOption
          [class.highlight]="item.option.highlight"
          [class.root-level]="item.level === 1"
          class="easy-option"
          [value]="item.option[valueAttribute] ?? item.option"
          [disabled]="
            (limitReached && !value.includes(matOption.value)) ||
            item.option.disabled ||
            item.option.count === 0
          "
        >
          <div class="d-flex justify-content-between align-items-center">
            <span
              >{{ item.option[labelAttribute] ?? item.option | translate
              }}{{
                item.option.count >= 0 ? " (" + item.option.count + ")" : ""
              }}</span
            >
            <app-status-chip
              *ngIf="showStatusLabel && matOption.selected"
              [status]="item.option.status"
            ></app-status-chip>
          </div>
        </mat-option>
      </ng-template>

      <ng-template let-item #matOptionGroup>
        <mat-optgroup
          class="option-group-{{ item.level }}"
          [label]="item.option[groupLabelAttribute] | translate"
        >
          <ng-container *ngFor="let opt of item.option[groupOptionsAttribute]">
            <ng-container
              *ngIf="opt[groupLabelAttribute]; else groupSimpleOption"
            >
              <ng-container
                *ngTemplateOutlet="
                  matOptionGroup;
                  context: { $implicit: { option: opt, level: item.level + 1 } }
                "
              ></ng-container>
            </ng-container>
            <ng-template #groupSimpleOption>
              <ng-container
                *ngTemplateOutlet="
                  simpleMatOption;
                  context: { $implicit: { option: opt, level: item.level + 1 } }
                "
              ></ng-container>
            </ng-template>
          </ng-container>
        </mat-optgroup>
      </ng-template>

      <ng-container *ngFor="let option of options; let i = index">
        <ng-container *ngIf="option[groupLabelAttribute]; else simpleOption">
          <ng-container
            *ngTemplateOutlet="
              matOptionGroup;
              context: { $implicit: { option: option, level: 1 } }
            "
          ></ng-container>
        </ng-container>
        <ng-template #simpleOption>
          <ng-container
            *ngTemplateOutlet="
              simpleMatOption;
              context: { $implicit: { option: option, level: 1 } }
            "
          ></ng-container>
        </ng-template>
      </ng-container>
    </mat-select>
  </div>

  <ng-container *ngIf="showErrorMessages">
    <mat-error
      id="{{ id }}-required-error"
      *ngIf="ngControl.touched && ngControl?.hasError('required')"
    >
      {{ "REQUIRED" | translate }}
    </mat-error>
  </ng-container>
  <mat-error
    class="d-flex align-items-center gap-2"
    id="{{ id }}-required-payment-method-error"
    *ngIf="
      ngControl.touched && ngControl?.hasError('requiredPaymentMethodError')
    "
  >
    <mat-icon>warning</mat-icon>
    <span>{{
      "ORDER_LIST.OFFER_DETAILS.CHOOSE_PAYMENT_METHOD" | translate
    }}</span>
  </mat-error>
</ng-container>

<mat-chip-listbox
  class="easy-chiplist mt-3"
  *ngIf="showSelectedLabels && multiple && value?.length"
>
  <mat-chip
    class="easy-chip"
    *ngFor="let item of value"
    [disabled]="ngControl.disabled"
    [attr.aria-readonly]="readonly"
    (removed)="removeSelected(item)"
    >{{
      translatePrefixForSelected + (item[labelAttribute] ?? item) | translate
    }}
    <button matChipRemove *ngIf="!ngControl.disabled">
      <mat-icon>cancel</mat-icon>
    </button></mat-chip
  >
</mat-chip-listbox>
